import { render } from "./Overtime.vue?vue&type=template&id=b8c13680&scoped=true"
import script from "./Overtime.vue?vue&type=script&lang=js"
export * from "./Overtime.vue?vue&type=script&lang=js"

import "./Overtime.vue?vue&type=style&index=0&id=b8c13680&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c13680"]])

export default __exports__